import styled from 'styled-components';

export const Wrapper = styled.div`
  .info-icon {
    width: 20px;
  }

  .copy-icon {
    font-size: 16px;
  }
`;

export const DateDropdownWrapper = styled.div`
  display: inline-flex;
  width: 100%;

  #composition-button.MuiButtonBase-root {
    padding: 6px 8px 7px 10px;
  }
`;
